<template>
  <div
    class="container slider-parceiros justify-content-center align-items-center "
    :style="`min-height: 285px;`"
  >
    <div
      class="font-glacial-regular font-70 title pt-4 mt-xl-0 text-center mb-4"
      v-html="tituloComputed"
    >
      <h2>
        {{ data.titulo }}
      </h2>
    </div>
    <!-- <div class="row justify-content-center mb-5">
            <div class="col-xl-10 text-center align-self-center font-glacial-regular font-18" :style="`color: #333333; line-height: 1.8`">
                {{data.descricao}}
            </div>
        </div> -->
    <div class="mb-5 pb-3">
      <div ref="observerParceiros"></div>
      <transition enter-active-class="animated fadeInUp">
        <slick :options="slickOptions" v-if="showObserver">
          <div
            class="d-flex justify-content-center align-items-center"
            v-for="(row, index) in photos"
            :key="index"
          >
            <b-img :data-lazy="`${row.foto.url}`" alt="" class="logo-parceiro" />
          </div>
        </slick>
      </transition>
    </div>
  </div>
</template>
<script>
import observer from "intersection-observer";

export default {
  props: {
    data: null,
  },

  data() {
    return {
      showObserver: false,

      slickOptions: {
        lazyLoad: "ondemand",
        arrows: true,
        slidesToShow: 5,
        responsive: [
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
    };
  },

  mounted() {
    var observer = new IntersectionObserver((entries) => {
      // If intersectionRatio is 0, the target is out of view
      // and we do not need to do anything.
      if (entries[0].intersectionRatio <= 0) {
        return;
      }
      this.showObserver = true;
      observer.unobserve(this.$refs.observerParceiros);
    });

    observer.POLL_INTERVAL = 100;
    observer.observe(this.$refs.observerParceiros);
  },

  computed: {
    tituloComputed() {
      var result = this.data.titulo;
      var firstWord = result.substr(0, result.indexOf(" "));
      result = result.replace(firstWord, "");

      firstWord = `<strong>${firstWord}</strong>`;

      result = firstWord + result;

      return result;
    },

    photos() {
      if (!this.data || !this.data.fotos || this.data.fotos.length == 0) {
        return [];
      }

      return this.shuffle(this.data.fotos);
    },
  },
};
</script>
<style scoped>
.logo-parceiro {
  max-height: 100px;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/parceiros.vue